import React from "react";
import Typography from "@material-ui/core/Typography";
import { ServiceMessaging } from "../../components/Administration/ServiceMessaging/ServiceMessaging";

/**
 * Display Service Messaging actions
 */
export const ServiceMessagingPage = () => {
	return (
		<div>
			<Typography style={{ marginBottom: 24 }} variant="h4" data-testid="service-messaging-page">
				Service Messaging
			</Typography>
			<ServiceMessaging />
		</div>
	);
};
